import { useTranslation } from 'react-i18next';
import { RhfTextField, type RhfTextFieldProps } from './shared/RhfTextField';

export type RegistrationNameFieldProps = Omit<RhfTextFieldProps, 'label'> & {
  label?: string;
};

/**
 * `RegistrationNameField` — RHF-bound text input for
 * `Org.legal.registrationName` (the legal entity name as it
 * appears on the commercial registration document, e.g.
 * "Acme Logistics Co.").
 *
 * Distinct from the platform display name (`Org.name`) — see
 * `DisplayNameField`.
 *
 * Labels come from `m-organization:form.company_name`, which is
 * the long-standing key for the legal/CR name across customer-
 * dashboard, carrier-dashboard, and admin-panel.
 */
export function RegistrationNameField(props: RegistrationNameFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfTextField
      {...props}
      label={props.label ?? t('form.company_name.title')}
      placeholder={props.placeholder ?? t('form.company_name.placeholder')}
      helper={props.helper ?? t('form.company_name.helper')}
    />
  );
}
